import { graphql } from 'react-relay';
import { useTranslation } from '@/helpers/translate';
import { wasUseFragment as useFragment } from '@/helpers/common';

const queryStations = graphql`
  fragment stations_stations on GeoTransportStation @relay(plural: true) {
    name
    dist
    lines {
      name
      type
    }
  }
`;

function Stations({ stations }) {
  const { t } = useTranslation();
  if (!stations?.length) return null;
  return (
    <section className="flex flex-wrap mt-12 md:mt-16 md:flex-row text-dark">
      <h2 className="w-full pt-8 pb-5 text-xl font-medium text-black border-t border-white-dark2 md:pt-12">{t('space:title.nearby_station')}</h2>
      <div className="flex flex-col space-y-2 md:space-y-0 md:flex-row md:space-x-2">
        {stations.map((station) => (
          <div className="px-4 py-3 text-black border rounded-lg border-purple-6/10" key={`station${station.name}`}>
            <div className="flex">
              {!station.lines || station.lines.map((l) => (
                <div className="pr-6" key={`stationslines${l.name}`}>
                  <img alt="transport" className="w-5 h-5" src={`/imgv4/transport/${l.name.toLowerCase()}.svg`} />
                </div>
              ))}
            </div>
            <div className="flex text-sm pt-7">
              <span className="flex items-center font-medium leading-5">{station.name}</span>
              <span className="ml-2 text-purple-5/50">
                {Math.round(station.dist)}
                m
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default function RootComponent(_props) {
  const { stations: _dataStations, ...props } = _props || {};
  const stations = useFragment(queryStations, _dataStations);
  return <Stations {...{ stations }} {...props} />;
}
